export default __webpack_public_path__ + "static/media/img1.87eabd89.png";